module.exports = __webpack_public_path__ + "boy-border-gray.png";